<ng-container *ngIf="primaryFacility">
  <div class="facility-header-wrapper" [class.is-collapsed]="isCollapsed" data-testid="fac-header-wrapper">
    <!-- Main Info Card -->
    <div class="facility-card" data-testid="fac-header-card">
      <div class="facility-content">
        <!-- Top Section: Identity, Address, and Alerts (3 Columns) -->
        <div class="facility-details-row">
          <!-- Col 1: Identity -->
          <div class="facility-identity">
            <div class="header-name-row">
              <dx-button [icon]="isCollapsed ? 'chevrondown' : 'chevronup'" class="collapse-toggle-btn"
                hint="{{ isCollapsed ? 'Show Details' : 'Hide Details' }}" (onClick)="toggleCollapse()"
                [elementAttr]="{ 'data-testid': 'fac-header-btn-toggle-collapse' }">
              </dx-button>
              <div class="name-container">
                <div class="label-ordering">Ordering for:</div>
                <h2 class="facility-name">{{ primaryFacility.name }}</h2>
              </div>
              </div>
            
            <div class="licenses-container" *ngIf="!isCollapsed">
              <div *ngIf="primaryFacility.dea_number && featureFlagsService.getByEnv('ui','DEA')" class="license-item">
                <span class="license-label">DEA:</span>
                <span class="license-value">{{ primaryFacility.dea_number }}</span>
              </div>
              <div *ngIf="primaryFacility.state_license" class="license-item">
                <span class="license-label">State License:</span>
                <span class="license-value">{{ primaryFacility.state_license }}</span>
              </div>
              <div class="license-item">
                <span class="license-label">Portal Account ID:</span>
                <span class="license-value">{{ primaryFacility.company_id }}-{{primaryFacility.id}}</span>
              </div>
              <div *ngIf="company?.dwolla_customer_id && primaryFacility.vendor_number" class="license-item">
                <span class="license-label">Caretria Account ID:</span>
                <span class="license-value">{{company?.dwolla_customer_id}}-{{ primaryFacility.vendor_number }}</span>
              </div>
            </div>
          </div>

          <!-- Col 2: Shipping Address -->
          <div class="facility-shipping" *ngIf="!isCollapsed">
            <div class="shipping-label-row">
              <div class="label-shipping">Shipping To:</div>
              <dx-button *ngIf="canEditFacility" icon="edit" class="edit-address-btn" stylingMode="text" (onClick)="openEditFacilityModal()" hint="Edit Address"></dx-button>
            </div>
            <address class="shipping-address">
              {{ primaryFacility.delivery_address.line_1 | titlecase }}<br />
              <ng-container *ngIf="primaryFacility.delivery_address.line_2">
                {{ primaryFacility.delivery_address.line_2 | titlecase }}<br />
              </ng-container>
              <ng-container *ngIf="primaryFacility.delivery_address.line_3">
                {{ primaryFacility.delivery_address.line_3 | titlecase }}<br />
              </ng-container>
              {{ primaryFacility.delivery_address.city | titlecase }},
              {{ primaryFacility.delivery_address.state }},
              {{ primaryFacility.delivery_address.postal_code }}
            </address>
          </div>

          <!-- Col 3: Alert Section -->
          <div *ngIf="expiredLicense || expiredMessage" class="facility-alert-column">
             <!-- Alert Section -->
            <div class="alert-container">
              <div class="expired-alert">
                <div class="alert-icon">
                  <i class="dx-icon-warning"></i>
                </div>
                <div class="alert-content">
                  <div class="alert-title">Expired Documents</div>
                  <div class="alert-message">
                    {{ expiredMessage }} Update it <a [routerLink]="['/pharmacies']" class="alert-link">here</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Bottom Section: Actions and Alerts -->
        <div class="row no-gutters mt-3" *ngIf="!isCollapsed">
          <div [class]="!isSmall ? 'col-lg-8' : 'col-12'">
            <!-- <div *ngIf="termsWarningVisible">
              <div class="alert alert-warning align-middle">
                Customer has not yet agreed to the terms and conditions for this facility.
                <div class="mt-2 d-flex flex-wrap">
                  <span class="mr-3">Contact: <b>{{primaryFacility.contact_name}}</b></span>
                  <span class="mr-3">Phone: <b>{{ primaryFacility.phone }}</b></span>
                  <span>Email: <b>{{ primaryFacility.email }}</b></span>
                </div>
              </div>
            </div> -->
          </div>
          <div *ngIf="!isSmall" class="col-lg-4">
            <div class="facility-actions-row border-0 pt-0 mt-0">
              <div class="actions-container">
                <dx-button type="default" stylingMode="outlined" text="Place Order" class="action-btn"
                  (onClick)="router.navigate(['/catalog'])"
                  [elementAttr]="{ 'data-testid': 'fac-header-btn-place-order' }"></dx-button>
                <dx-button type="default" stylingMode="outlined" text="Order Details" class="action-btn"
                  (onClick)="router.navigate(['/orders'])"
                  [elementAttr]="{ 'data-testid': 'fac-header-btn-order-details' }"></dx-button>
                <dx-button type="default" stylingMode="outlined" text="Facility Info" class="action-btn"
                  (onClick)="router.navigate(['/pharmacies'])"
                  [elementAttr]="{ 'data-testid': 'fac-header-btn-facility-info' }"></dx-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Vetted Warning Banner -->
      <div *ngIf="!isCollapsed && !primaryFacility.vetted" class="vetted-warning">
        <div class="warning-content">
          You have not yet been approved as a buyer, so you cannot see direct pricing yet.
        </div>
      </div>

      <!-- Past Due Warning Banner -->
      <div
        *ngIf="!isCollapsed && pastDueCount > 0"
        class="vetted-warning past-due-warning"
        style="cursor: pointer;"
        (click)="pastDue.routeToPastDue(pastDueSummary, primaryFacility.id)"
        data-testid="fac-header-past-due-warning"
      >
        <div class="warning-content">
          {{ pastDueCount }} orders past due &middot; {{ pastDueAmount | currency }} outstanding
        </div>
      </div>
    </div>
  </div>
</ng-container>

<app-edit-facility-modal
  *ngIf="showEditFacilityModal"
  [(visible)]="showEditFacilityModal"
  [facilityId]="editFacilityId"
  [formData]="editFacilityFormData"
  (onUpdate)="getProfileInformation()"
></app-edit-facility-modal>
